var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-log"},[_c('el-input',{model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_c('ul',_vm._l((_vm.filterData),function(value,key){return _c('li',{key:key},[_vm._v(" "+_vm._s(value.log)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }